import { render, staticRenderFns } from "./NumberPerson.vue?vue&type=template&id=6d4abada&scoped=true&"
import script from "./NumberPerson.vue?vue&type=script&lang=js&"
export * from "./NumberPerson.vue?vue&type=script&lang=js&"
import style0 from "./NumberPerson.vue?vue&type=style&index=0&id=6d4abada&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4abada",
  null
  
)

export default component.exports